import { handleActions } from 'redux-actions'
import actions, { TYPES } from '../actions'

const initialState = {
  currentProduct: null,
  searchProductResults: null,
  currentStore: null,
  q: '',
  searchLoading: false,
  productsLoading: false,
  storesLoading: false,
  stores: null,
  products: null,
  view: TYPES.VIEW_EMPTY,
  mobileBottomShow: true,
  retailDone: false,
  storesFetched: false,
  dialogSearchAddress: false,
  showStoreInformation: true,

  drawerProductDetails: null,
  isOpenDrawerProductDetails: false,
  loadingProduct: false,

  // produtos selecionados!
  selected: [],
  chart: {
    data: [],
    load: false,
    period: 'last30Days'
  }
}

const reducer = handleActions(
  {
    [actions.updateApp]: (state, action) => ({ ...state, ...action.payload }),

    [actions.searchProducts]: (state, action) => ({
      ...state,
      q: action.payload
    }),

    [actions.selectProduct]: (state, { payload }) => {
      let selected = state.selected
      const index = state.selected.findIndex((i) => i.gtin === payload.gtin)

      if (index !== -1) {
        selected = [...selected.slice(0, index), ...selected.slice(index + 1)]
      } else {
        selected = [].concat(...state.selected, payload)
      }

      return {
        ...state,
        selected
        // currentProduct: payload,
      }
    },

    [actions.toggleBottom]: (state) => ({
      ...state,
      mobileBottomShow: !state.mobileBottomShow
    }),

    [actions.network]: (state, { payload }) => ({
      ...state,
      offline: payload.status
    }),

    /** stores */
    [actions.storesStart]: (state, { payload }) => ({
      ...state,
      currentProduct: payload,
      storesLoading: true,
      view: TYPES.VIEW_STORES
    }),
    [actions.storesError]: (state) => ({
      ...state,
      storesLoading: false
    }),
    [actions.storesSuccess]: (state, { payload }) => ({
      ...state,
      ...payload,
      storesLoading: false
    }),
    [actions.selectStore]: (state, { payload }) => ({
      ...state,
      currentStore: payload,
      showStoreInformation: true
    }),
    [actions.showStoreInformation]: (state, { payload }) => ({
      ...state,
      showStoreInformation: payload
    }),
    [actions.storesNotFound]: (state, { payload }) => ({
      ...state,
      ...payload,
      stores: null,
      storesLoading: false
    }),

    /** products */
    [actions.products.start]: (state) => ({
      ...state,
      productsLoading: true,
      view: TYPES.VIEW_PRODUCTS
    }),
    [actions.products.error]: (state) => ({
      ...state,
      productsLoading: false
    }),
    [actions.products.success]: (state, { payload }) => ({
      ...state,
      productsLoading: false,
      products: payload
    }),

    [actions.chart.data]: (state, { payload }) => ({
      ...state,
      chart: {
        ...state.chart,
        data: payload
      }
    }),
    [actions.chart.period]: (state, { payload }) => ({
      ...state,
      chart: {
        ...state.chart,
        period: payload
      }
    }),
    [actions.chart.load]: (state, { payload }) => ({
      ...state,
      chart: {
        ...state.chart,
        load: payload
      }
    }),
    [actions.chart.reset]: (state) => ({
      ...state,
      chart: {
        data: [],
        load: false,
        period: 'last30Days'
      }
    }),

    [actions.openDrawerProduct]: (state, { payload }) => ({
      ...state,
      drawerProductDetails: payload,
      isOpenDrawerProductDetails: true
    }),
    [actions.closeDrawerProduct]: (state) => ({
      ...state,
      drawerProductDetails: null,
      isOpenDrawerProductDetails: false
    }),
    [actions.loadingProduct]: (state, { payload }) => ({
      ...state,
      loadingProduct: payload,
      isOpenDrawerProductDetails: payload ? payload : state.isOpenDrawerProductDetails
    })
  },
  initialState
)

export default reducer
